export function mapSignedUrlToImages(content: string, urlObject?: Record<string, string>) {
  if (!content || !urlObject) return content;
  const signedUrlsObj = urlObject;

  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');
  const images = doc.getElementsByTagName('img');

  for (const img of Array.from(images)) {
    const filename = img.getAttribute('content');
    if (filename && signedUrlsObj[filename]) {
      img.setAttribute('src', signedUrlsObj[filename]);
      img.removeAttribute('content');
    }
  }

  return doc.body.innerHTML;
}
